<template>
  <div>
    <v-row class="mt-4 mb-8 pl-2" align="center">
      <v-icon large>mdi-account-lock</v-icon>
      <h2 class="text-h5 pl-2">Módulo Controle de Acesso</h2>
    </v-row>

    <v-row no-gutters>
      <div class="text-h6">Cadastro de Usuário</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoCadastroUsuario"
          :items="permissionsCadastroUsuario"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Cadastro de Perfil</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoCadastroPerfil"
          :items="permissionsCadastroPerfil"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Auditoria</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoAuditoria"
          :items="permissionsAuditoria"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Token</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :disabled="permissaoVisualizar || id == 1"
          dense
          v-model="selecionadoToken"
          :items="permissionsToken"
          label="Selecione o nível de permissão"
          outlined
          class="mt-3"
        />
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-n2">
      <div class="text-h6">Perfis Permitidos</div>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          dense
          outlined
          multiple
          label="Perfis"
          v-model="selectedPerfis"
          :items="perfis"
          class="mt-2"
          :disabled="
            (selecionadoCadastroUsuario !==
              dictionaryRoles.controleAcessoUsuariosVisualizarCondicionado.id &&
              selecionadoCadastroUsuario !==
                dictionaryRoles.controleAcessoUsuariosEditarCondicionado.id) ||
              permissaoVisualizar ||
              id == 1
          "
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ item.text }}</span>
            <v-chip v-if="index === 1" small>
              <span class="caption"> (+{{ selectedPerfis.length - 1 }}) </span>
            </v-chip>
          </template>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="togglePerfis">
              <v-list-item-action>
                <v-icon
                  :color="selectedPerfis.length > 0 ? 'indigo darken-4' : ''"
                >
                  {{ iconSelectedPerfis }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Selecionar Todos
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2" />
          </template>
        </v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { registerVuexModule } from "@/utils/vuexUtils";
import { obtainUserPermissions } from "@/utils/obtainUserPermissions";
import { addAndRemovePermissions } from "../_utils/addAndRemovePermissions";
import { dictionaryRoles } from "../_utils/dictionaryRoles";

import roleStore from "../_store";

export default {
  data: () => ({
    dictionaryRoles: dictionaryRoles,
    permissaoVisualizar: false,
    initPermissoes: false,
    // Select Perfis Permitidos
    perfis: [],
    selectedPerfis: [],
    initiatedPerfis: false,
    // Cadastro de Usuário
    permissionsCadastroUsuario: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text:
          dictionaryRoles.controleAcessoUsuariosVisualizarCondicionado
            .description,
        value: dictionaryRoles.controleAcessoUsuariosVisualizarCondicionado.id,
      },
      {
        text:
          dictionaryRoles.controleAcessoUsuariosEditarCondicionado.description,
        value: dictionaryRoles.controleAcessoUsuariosEditarCondicionado.id,
      },
      {
        text: dictionaryRoles.controleAcessoUsuariosTotal.description,
        value: dictionaryRoles.controleAcessoUsuariosTotal.id,
      },
    ],
    selecionadoCadastroUsuario: null,
    // Cadastro de Perfil
    permissionsCadastroPerfil: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.controleAcessoPerfilVisualizar.description,
        value: dictionaryRoles.controleAcessoPerfilVisualizar.id,
      },
      {
        text: dictionaryRoles.controleAcessoPerfilEditar.description,
        value: dictionaryRoles.controleAcessoPerfilEditar.id,
      },
      {
        text: dictionaryRoles.controleAcessoPerfilTotal.description,
        value: dictionaryRoles.controleAcessoPerfilTotal.id,
      },
    ],
    selecionadoCadastroPerfil: null,
    // Auditoria
    permissionsAuditoria: [
      {
        text: "Sem Acesso",
        value: null,
      },
      // {
      //   text:
      //     dictionaryRoles.controleAcessoAuditoriaVisualizarCondicionado
      //       .description,
      //   value: dictionaryRoles.controleAcessoAuditoriaVisualizarCondicionado.id,
      // },
      {
        text: dictionaryRoles.controleAcessoAuditoriaTotal.description,
        value: dictionaryRoles.controleAcessoAuditoriaTotal.id,
      },
    ],
    selecionadoAuditoria: null,
    // Token
    permissionsToken: [
      {
        text: "Sem Acesso",
        value: null,
      },
      {
        text: dictionaryRoles.controleAcessoTokenVisualizar.description,
        value: dictionaryRoles.controleAcessoTokenVisualizar.id,
      },
    ],
    selecionadoToken: null,
  }),

  computed: {
    ...mapGetters("moduloPABXStepStore", [
      "getAllRoles",
      "getSelectedRoles",
      "getPermissoes",
    ]),
    todosPerfisSelecionados() {
      return this.selectedPerfis.length === this.perfis.length;
    },
    algunsPerfisSelecionados() {
      return this.selectedPerfis.length > 0 && !this.todosPerfisSelecionados;
    },
    iconSelectedPerfis() {
      if (this.todosPerfisSelecionados) return "mdi-close-box";
      if (this.algunsPerfisSelecionados) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  async created() {
    this.initPermissoes = false;
    registerVuexModule(this.$store, "moduloPABXStepStore", roleStore);

    await this.listAllRoles();
    this.perfis = this.getAllRoles.map((role) => ({
      text: role.name,
      value: role.id,
    }));
    this.selectedPerfis = this.getSelectedRoles;

    const arrayPermissions = this.arrayPermissionsFromLocalStorage();
    if (
      arrayPermissions.includes(
        process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_VISUALIZAR
      )
    ) {
      this.permissaoVisualizar = true;
    }
  },

  methods: {
    ...mapActions("moduloPABXStepStore", [
      "listAllRoles",
      "setSelectedRoles",
      "addPermissionsID",
      "deletePermissionsID",
    ]),
    ...obtainUserPermissions,
    ...addAndRemovePermissions,

    togglePerfis() {
      this.$nextTick(() => {
        if (this.todosPerfisSelecionados) {
          this.selectedPerfis.splice(0);
        } else {
          this.selectedPerfis.splice(0);
          this.selectedPerfis = this.perfis.map((operador) => operador.value);
        }
      });
    },
  },

  watch: {
    selectedPerfis: {
      deep: true,
      async handler() {
        await this.setSelectedRoles(this.selectedPerfis);
      },
    },
    getSelectedRoles: {
      deep: true,
      handler() {
        if (!this.initiatedPerfis) {
          this.selectedPerfis = [...this.getSelectedRoles];
          this.initiatedPerfis = true;
        }
      },
    },
    // Monitora permissoes
    getPermissoes: {
      deep: true,
      handler(newValue) {
        if (!this.initPermissoes) {
          this.initPermissoes = true;
          // Cadastro de Usuário
          if (
            newValue.includes(
              dictionaryRoles.controleAcessoUsuariosVisualizarCondicionado.id
            ) &&
            !this.initCadastroUsuario
          ) {
            this.selecionadoCadastroUsuario =
              dictionaryRoles.controleAcessoUsuariosVisualizarCondicionado.id;
            this.initCadastroUsuario = true;
          } else if (
            newValue.includes(
              dictionaryRoles.controleAcessoUsuariosEditarCondicionado.id
            ) &&
            !this.initCadastroUsuario
          ) {
            this.selecionadoCadastroUsuario =
              dictionaryRoles.controleAcessoUsuariosEditarCondicionado.id;
            this.initCadastroUsuario = true;
          } else if (
            newValue.includes(dictionaryRoles.controleAcessoUsuariosTotal.id) &&
            !this.initCadastroUsuario
          ) {
            this.selecionadoCadastroUsuario =
              dictionaryRoles.controleAcessoUsuariosTotal.id;
            this.initCadastroUsuario = true;
          }
          // Cadastro de Perfil
          if (
            newValue.includes(
              dictionaryRoles.controleAcessoPerfilVisualizar.id
            ) &&
            !this.initCadastroPerfil
          ) {
            this.selecionadoCadastroPerfil =
              dictionaryRoles.controleAcessoPerfilVisualizar.id;
            this.initCadastroPerfil = true;
          } else if (
            newValue.includes(dictionaryRoles.controleAcessoPerfilEditar.id) &&
            !this.initCadastroPerfil
          ) {
            this.selecionadoCadastroPerfil =
              dictionaryRoles.controleAcessoPerfilEditar.id;
            this.initCadastroPerfil = true;
          } else if (
            newValue.includes(dictionaryRoles.controleAcessoPerfilTotal.id) &&
            !this.initCadastroPerfil
          ) {
            this.selecionadoCadastroPerfil =
              dictionaryRoles.controleAcessoPerfilTotal.id;
            this.initCadastroPerfil = true;
          }
          // Auditoria
          if (
            newValue.includes(
              dictionaryRoles.controleAcessoAuditoriaVisualizarCondicionado.id
            ) &&
            !this.initAuditoria
          ) {
            this.selecionadoAuditoria =
              dictionaryRoles.controleAcessoAuditoriaVisualizarCondicionado.id;
            this.initAuditoria = true;
          } else if (
            newValue.includes(
              dictionaryRoles.controleAcessoAuditoriaTotal.id
            ) &&
            !this.initAuditoria
          ) {
            this.selecionadoAuditoria =
              dictionaryRoles.controleAcessoAuditoriaTotal.id;
            this.initAuditoria = true;
          }
          // Token
          if (
            newValue.includes(
              dictionaryRoles.controleAcessoTokenVisualizar.id
            ) &&
            !this.initToken
          ) {
            this.selecionadoToken =
              dictionaryRoles.controleAcessoTokenVisualizar.id;
            this.initToken = true;
          }
        }
      },
    },
    //Monitora Selects
    selecionadoCadastroPerfil: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoCadastroUsuario: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoAuditoria: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
    selecionadoToken: {
      deep: true,
      handler(newValue, oldValue) {
        this.addAndRemovePermissions(newValue, oldValue);
      },
    },
  },
};
</script>
